module.exports = __webpack_public_path__ + "6dbf9df9685b783584fe48f8486e7b26.jpg";